import { HelpCircle, RotateCcw } from 'lucide-react';
import React, { useState } from 'react';
import FilteredInputDropdown from 'src/components/ui/filtered-input-dropdown';
import { Company } from 'src/pages/billing/types/billing.types';
import { Button } from 'src/components/ui/button';

interface InvoiceCreationContainerProps {
  companies: Company[];
  isCreating: boolean;
  onCreate?: (companyId: string) => void;
}

const InvoiceCreationContainer: React.FC<InvoiceCreationContainerProps> = ({
  isCreating,
  onCreate,
  companies,
}) => {
  const [selectedCompanyId, setSelectedCompanyId] = useState<string | undefined>(undefined);

  return (
    <div className="p-4 pt-2 bg-gray-201">
      <div className='flex flex-row gap-2 items-center mb-1'>
        <HelpCircle className="h-4 w-4" />
        <p className='text-xs text-gray-600'>
          Choose a company to create a new invoice for.
        </p>
      </div>
      {isCreating ? (
        <div className='flex flex-col justify-center items-center gap-2'>
          <RotateCcw className='h-12 w-12 animate-spin' />
          Creating...
        </div>
      ) : (
        <div className='flex flex-row gap-2 items-center'>
          <div className='w-full'>
            <FilteredInputDropdown
              inputClassName='bg-gray-300 rounded-xl '
              options={companies?.map((company) => ({
                value: company.id,
                label: company.company_name || company.id,
              })) || []}
              selectedValue={selectedCompanyId}
              onSelect={(value: string) => {
                setSelectedCompanyId(value);
              }}
              placeholder="Search for a company..."
            />
          </div>
          <div>
            <Button
              className='p-2 px-4 cursor-pointer rounded-full bg-gray-200 h-auto hover:bg-gray-201/90 hover:border-gray-600 hover:border-1'
              disabled={!selectedCompanyId}
              variant='ghost'
              onClick={() => {
                onCreate?.(selectedCompanyId as string);
              }}
            >
              Submit
            </Button>
          </div>

        </div>
      )}
    </div>
  );
};

export default InvoiceCreationContainer;
